import { createFileRoute } from '@tanstack/react-router';

import { PlacementsPage } from '../features/supply/placements/PlacementsPage';
import { placementsRouteSearchSchema } from '../features/supply/placements/placementsRouteSearch';

export const Route = createFileRoute('/supply/placements')({
  validateSearch: placementsRouteSearchSchema,
  component: PlacementsPage,
});
